import { i18n } from "@dehub/theme"
import { translateBackendError } from "../delivery/translate-error"

/**
 * Route action error -> readable text (O10 / O121). The route logics throw plain English strings
 * ("Cannot complete route: 2 stop(s) not yet delivered/closed", "Cannot start from status X"), which
 * the route handler wraps as a validation error; those are recognised here and mapped to errors-namespace
 * keys, everything else goes through the shared `error.*` key translator.
 */
export function translateRouteError(err: unknown, fallbackKey = "error.route.action_failed"): string {
  const raw = typeof err === "string" ? err : (err as { message?: string } | null)?.message ?? ""
  const open = /^Cannot complete route: (\d+) stop\(s\) not yet delivered\/closed/.exec(raw)
  if (open) return i18n.t("error.route.stops_not_closed", { ns: "errors", count: Number(open[1]) })
  if (/^Cannot (complete|start|mark loading complete) from status/.test(raw)) {
    return i18n.t("error.route.wrong_status", { ns: "errors" })
  }
  return translateBackendError(err, fallbackKey)
}
